import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { MegaTagTitle } from 'components/Elements'
import { PageContent, PageHeader } from 'components/Layouts'
import { RecommendedCandidatesContainer } from 'features/job/components/JobCandidates/Recommendations'

export const Recommendations = () => {
  const { t } = useTranslation()

  return (
    <>
      <MegaTagTitle title={'recommendations'} />

      <PageContent>
        <PageHeader back />

        <RecommendedCandidatesContainer />
      </PageContent>
    </>
  )
}

Recommendations.propTypes = {}
